<template>
    <div>
        <!-- For Motor NB -->
        <div class="row app-overview-wrapper" v-if="checkMotorParent">
            <div class="col-12">
                <div class="row app-overview-row">
                    <div class="col-6 col-md-4 col-lg-2 quote-summary mt-1 pt-2">
                        <div class="row">
                            <p><span class="label-value">Policy Summary</span></p>
                        </div>
                    </div>
                    <div class="col-6 col-md-4 col-lg-2 quotation-number">
                        <div class="row ">
                            <p><span class="label-name">POLICY NO.</span><br>
                            <span class="label-value">{{getSavedQuoteData.policyNo}}</span></p>
                        </div>
                    </div>
                    <div class="col-6 col-md-4 col-lg-2 make-n-model">
                        <div class="row">
                            <p><span class="label-name">VEHICLE  MAKE & MODEL</span><br>
                            <span class="label-value">{{makeModelName}}</span></p>
                        </div>
                    </div>
                    <div class="col-6 col-md-4 col-lg-1 pr-lg-0 product-name">
                        <div class="row">
                            <p><span class="label-name">PRODUCT NAME</span><br>
                            <span class=" label-value">{{productName}}</span>
                            </p>
                        </div>
                    </div>
                    <div class="col-6 col-md-4 col-lg-2 plan-name">
                        <div class="row">
                            <p><span class="label-name">PLAN NAME</span><br>
                            <span class=" label-value">{{planName}}</span>
                            </p>
                        </div>
                    </div>
                    <div class="col-6 col-md-4 col-lg-1 plan-tenure">
                        <div class="row">
                            <p><span class="label-name">PLAN TENURE</span><br>
                            <span class=" label-value">{{state.quoteObj.planTenure}} <span v-if="state.quoteObj.planTenure=='1'"> Year</span><span v-else> Years</span></span>
                            </p>
                        </div>
                    </div>
                    <div class="col-12 col-md-12 col-lg-2">
                        <div class="row">
                            <p><span class="label-name">{{premiumType?premiumType:'OUTSTANDING AMOUNT'}}</span><br>
                            <span class="label-value">&#8377; {{premiumType=='REFUND AMOUNT'? refundAmount : outstandingPremium}}</span></p>
                        </div>
                    </div>
                    <div class="preview-btn-wrapper review-application" v-if="false">
                        <button id="review_application" type="button" class="preview collapsed" data-toggle="collapse" data-target="#details_payment">Review Application</button>
                    </div>
                </div>
            </div>
            <!-- review application section starts -->
            <div class="col-12 app-overview-outer-div collapse px-lg-0 px-md-0" id="details_payment">
                <div class="app-overview-inner-div">
                    <div class="row pt-4 pb-3 ml-md-4 ml-2 mr-0">
                        <div class="col-12 col-md-3 pb-3 pb-md-0 col-lg-2">
                            <div class="row label-name">Registration Number</div>
                            <div class="row inner-label-value">{{getSavedQuoteData.riskDetails.registrationNumber?getSavedQuoteData.riskDetails.registrationNumber:'-'}}</div>
                        </div>
                        <div class="col-12 col-md-3 pb-3 pb-md-0 col-lg-2">
                            <div class="row label-name">Title</div>
                            <div class="row inner-label-value">{{searchPartyData.title?searchPartyData.title:'-'}}</div>
                        </div>
                        <div class="col-6 col-md-3 col-lg-2">
                            <div class="row label-name">First Name</div>
                            <div class="row inner-label-value">{{searchPartyData.firstName?searchPartyData.firstName:'-'}}</div>
                        </div>
                        <div class="col-6 col-md-3 col-lg-2">
                            <div class="row label-name ">Middle Name</div>
                            <div class="row inner-label-value">{{searchPartyData.middleName?searchPartyData.middleName:'-'}}</div>
                        </div>
                        <div class="col-6 col-md-3 col-lg-2 pl-lg-4">
                            <div class="row label-name ">Last Name</div>
                            <div class="row inner-label-value">{{searchPartyData.lastName?searchPartyData.lastName:'-'}}</div>
                        </div>
                        <div class="col-6 col-md-3 col-lg-2">
                            <div class="row label-name">Address</div>
                            <div class="row inner-label-value">{{searchPartyData.correspondenceAddress.addressLine1}}, {{searchPartyData.correspondenceAddress.area}}, 
                                {{searchPartyData.correspondenceAddress.city}}, {{searchPartyData.correspondenceAddress.state}}, {{searchPartyData.correspondenceAddress.pinCode}}
                            </div>
                        </div>
                    </div>
                    <div class="row pt-4 pb-3 ml-md-4 ml-2 mr-0">
                        <div class="col-6 col-md-3 pb-3 pb-md-0 col-lg-2">
                            <div class="row label-name">Email Id</div>
                            <div class="row inner-label-value  break-word">{{searchPartyData.emailId?searchPartyData.emailId:''}}</div>
                        </div>
                        <div class="col-6 col-md-3 pb-3 pb-md-0 col-lg-2">
                            <div class="row label-name">Mobile Number</div>
                            <div class="row inner-label-value">{{searchPartyData.mobileNo?searchPartyData.mobileNo:'-'}}</div>
                        </div>
                        <div class="col-6 col-md-3 col-lg-2">
                            <div class="row label-name ">Engine Number</div>
                            <div class="row inner-label-value">{{getSavedQuoteData.riskDetails.engineNumber}}</div>
                        </div>
                        <div class="col-6 col-md-3 col-lg-2">
                            <div class="row label-name">Chassis Number</div>
                            <div class="row inner-label-value">{{getSavedQuoteData.riskDetails.chassisNo}}</div>
                        </div>
                        <!-- <div class="col-6 col-md-3 pb-3 pb-md-0 col-lg-2 pl-lg-4">
                            <div class="row label-name">Nominee Name</div>
                            <div class="row inner-label-value">{{proposalDetailsData.personalAccidentCoverDetails.nomineeName ? proposalDetailsData.personalAccidentCoverDetails.nomineeName : '-'}}</div>
                        </div>
                        <div class="col-6 col-md-3 pb-3 pb-md-0 col-lg-2">
                            <div class="row label-name">Nominee Relationship</div>
                            <div class="row inner-label-value">{{proposalDetailsData.personalAccidentCoverDetails.nomineeRelation ? proposalDetailsData.personalAccidentCoverDetails.nomineeRelation : '-'}}</div>
                        </div> -->
                    </div>
                    <div class="row pt-4 pb-3 ml-md-4 ml-2 mr-0" v-if="searchPartyData.panNumber != ''">
                        <div class="col-6 col-md-3 col-lg-2">
                            <div class="row label-name ">PAN Number</div>
                            <div class="row inner-label-value">{{searchPartyData.panNumber ? searchPartyData.panNumber : '-'}}</div>
                        </div>
                    </div>
                </div>
                <!-- review application section ends -->
            </div>
        </div>
        <!-- For standaloneCPA -->
        <div class="row app-overview-wrapper" v-if="!checkMotorParent">
            <div class="col-12">
                <div class="row app-overview-row">
                    <!-- <div class="col-6 col-md-4 col-lg-2 quote-summary mt-1 pt-2">
                        <div class="row">
                            <p><span class="label-value">Quote Summary</span></p>
                        </div>
                    </div> -->
                    <div class="col-6 col-md-4 col-lg-2 pl-lg-4 quotation-number">
                        <div class="row ">
                            <p><span class="label-name">POLICY NO.</span><br>
                            <span class="label-value">{{getSavedQuoteData.policyNo}}</span></p>
                        </div>
                    </div>
                    <div class="col-6 col-md-4 col-lg-2 ml-lg-2 make-n-model">
                        <div class="row">
                            <p><span class="label-name">SCPA NOMINEE NAME</span><br>
                            <span class="label-value">{{getSavedQuoteData.scpaNomineeDetails.length>0 ?getSavedQuoteData.scpaNomineeDetails[0].scpaNomineeName ? getSavedQuoteData.scpaNomineeDetails[0].scpaNomineeName : '-' :'-'}}</span></p>
                        </div>
                    </div>
                    <div class="col-6 col-md-4 col-lg-2 pl-lg-0 ml-lg-0 product-name">
                        <div class="row">
                            <p><span class="label-name">SCPA NOMINEE RELATION</span><br>
                            <span class=" label-value">{{getSavedQuoteData.scpaNomineeDetails.length>0 ?getSavedQuoteData.scpaNomineeDetails[0].scpaNomineeRelation ? getSavedQuoteData.scpaNomineeDetails[0].scpaNomineeRelation : '-': '-'}}</span>
                            </p>
                        </div>
                    </div>
                    <div class="col-6 col-md-4 col-lg-2 plan-name">
                        <div class="row">
                            <p><span class="label-name">SCPA DURATION </span><br>
                            <span class=" label-value">{{getSavedQuoteData.cpaDuration?getSavedQuoteData.cpaDuration:'-'}}</span>
                            </p>
                        </div>
                    </div>
                    <div class="col-6 col-md-4 col-lg-1 pl-lg-0 plan-tenure">
                        <div class="row">
                            <p><span class="label-name">PARTY ID</span><br>
                            <span class=" label-value">{{getSavedQuoteData.partyId ? getSavedQuoteDat.partyId : '-'}}</span>
                            </p>
                        </div>
                    </div>
                    <div class="col-12 col-md-12 col-lg-2 pl-lg-0">
                        <div class="row">
                            <p><span class="label-name">TOTAL PREMIUM</span><br>
                            <span class="label-value">&#8377; {{premium}}</span></p>
                        </div>
                    </div>
                    <div class="preview-btn-wrapper review-application" >
                        <button id="rev_application" type="button" class="preview collapsed" data-toggle="collapse" data-target="#details_payment">Review Application</button>
                    </div>
                </div>
            </div>
            <!-- review application section starts -->
            <div class="col-12 app-overview-outer-div collapse px-lg-0 px-md-0" id="details_payment">
                <div class="app-overview-inner-div">
                    <div class="row pt-4 pb-3 ml-md-4 ml-2 mr-0">
                        <div class="col-12 col-md-3 pb-3 pb-md-0 col-lg-2">
                            <div class="row label-name">Title</div>
                            <div class="row inner-label-value">{{searchPartyData.title ? searchPartyData.title : '-'}}</div>
                        </div>
                        <div class="col-6 col-md-3 col-lg-2">
                            <div class="row label-name">First Name</div>
                            <div class="row inner-label-value">{{searchPartyData.firstName ? searchPartyData.firstName : '-'}}</div>
                        </div>
                        <div class="col-6 col-md-3 col-lg-2">
                            <div class="row label-name ">Middle Name</div>
                            <div class="row inner-label-value">{{searchPartyData.middleName ? searchPartyData.middleName : '-'}}</div>
                        </div>
                        <div class="col-6 col-md-3 col-lg-2">
                            <div class="row label-name ">Last Name</div>
                            <div class="row inner-label-value">{{searchPartyData.lastName ? searchPartyData.lastName : '-'}}</div>
                        </div>
                        <div class="col-6 col-md-3 col-lg-4">
                            <div class="row label-name">Address</div>
                            <div class="row inner-label-value">{{searchPartyData.correspondenceAddress.addressLine1}}, {{searchPartyData.correspondenceAddress.area}}, 
                                {{searchPartyData.correspondenceAddress.city}}, {{searchPartyData.correspondenceAddress.state}}, {{searchPartyData.correspondenceAddress.pinCode}}
                            </div>
                        </div>
                    </div>
                    <div class="row pt-4 pb-3 ml-md-4 ml-2 mr-0">
                        <div class="col-6 col-md-3 col-sm-6 pb-3 pb-md-0 col-lg-2">
                            <div class="row label-name">Email Id</div>
                            <div class="row inner-label-value break-word">{{searchPartyData.emailId ? searchPartyData.emailId : '-'}}</div>
                        </div>
                        <div class="col-6 col-md-3 col-sm-6 pb-3 pb-md-0 col-lg-2">
                            <div class="row label-name">Mobile Number</div>
                            <div class="row inner-label-value">{{searchPartyData.mobileNo ? searchPartyData.mobileNo : '-'}}</div>
                        </div>
                    </div>
                    <!-- <div class="row pt-4 pb-3 ml-md-4 ml-2 mr-0">
                        <div class="col-12 col-md-3 pb-3 pb-md-0 col-lg-2">
                            <div class="row label-name">Nominee Name</div>
                            <div class="row inner-label-value">Anupama</div>
                        </div>
                        <div class="col-12 col-md-3 pb-3 pb-md-0 col-lg-2">
                            <div class="row label-name">Nominee Relationship</div>
                            <div class="row inner-label-value">Text</div>
                        </div>
                        <div class="col-6 col-md-3 col-lg-2">
                            <div class="row label-name">Aadhar Card</div>
                            <div class="row inner-label-value">6140 4981 2385</div>
                        </div>
                        <div class="col-6 col-md-3 col-lg-2">
                            <div class="row label-name ">PAN Number</div>
                            <div class="row inner-label-value">AJXPD235D</div>
                        </div>
                    </div> -->
                </div>
                <!-- review application section ends -->
            </div>
        </div>
    </div>
</template>
<script>
import { reactive, computed, onMounted} from '@vue/composition-api';
export default {
  name: "ApplicationOverview",
  props: ['completedb','searchPartyData','getSavedQuoteData','makeModelName','planName','premiumType','refundAmount','outstandingPremium','productName'],
  components: {
  },
  setup(props , context){
    let state = reactive({
        quoteObj: {
            makeModelName: '',
            productName: '',
            title: '',
            planName: '',
            planTenure: '',
            gender: '',
            gstn: '',
            aadharCard: ''
        },
    });
    onMounted(()=>{
      setQuoteSummary();
    });
    //computed
    const checkMotorParent = computed(()=>{
      let obj = context.root.$store.getters.getMotorParentType;
      if(obj.standaloneCPA){
        return false;
      }
      return true;
    });
    //methods
    function setQuoteSummary(){
        state.quoteObj.planTenure = props.getSavedQuoteData.motorPolicyBasicDetails.planTenure.split("X")[1] == "0" ? props.getSavedQuoteData.motorPolicyBasicDetails.planTenure.split("X")[0]: props.getSavedQuoteData.motorPolicyBasicDetails.planTenure.split("X")[1];
        // state.quoteObj.quoteId = props.completedb.quoteId;
        // for(let i=0; i<props.completedb.generateQuote.riskDetails.vehicleMakeModelList.length; i++){
        //     if(props.generateQuoteData.riskDetails.make_model.value == props.completedb.generateQuote.riskDetails.vehicleMakeModelList[i].makeModelCode){
        //         state.quoteObj.makeModelName = props.completedb.generateQuote.riskDetails.vehicleMakeModelList[i].makeModelName
        //     }
        // }
        // for(let i=0; i<props.completedb.generateQuote.policyDetails.products.length; i++){
        //     if(props.generateQuoteData.policyDetails.productCode.value == props.completedb.generateQuote.policyDetails.products[i].code){
        //         state.quoteObj.productName = props.completedb.generateQuote.policyDetails.products[i].name
        //     }
        // }
        // for(let i=0; i<props.completedb.generateQuote.policyDetails.planArray.length; i++){
        //     if(props.generateQuoteData.policyDetails.planCode.value == props.completedb.generateQuote.policyDetails.planArray[i].planCode){
        //         state.quoteObj.planName = props.completedb.generateQuote.policyDetails.planArray[i].planName
        //     }
        // }
        // for(let i=0; i<props.completedb.proposalDetails.customerDetails.titleArray.length; i++){
        //     if(props.proposalDetailsData.customerDetails.title.value == props.completedb.proposalDetails.customerDetails.titleArray[i].code){
        //         state.quoteObj.title = props.completedb.proposalDetails.customerDetails.titleArray[i].name
        //     }
        // }
        // if(props.generateQuoteData.policyDetails.planCode.value == '1806'){
        //     state.quoteObj.planTenure = props.generateQuoteData.selectedPlan.value.split('X')[1];
        // }
        // else{
        //     state.quoteObj.planTenure = props.generateQuoteData.policyDetails.planTenure.value.split('X')[1];
        // } 
        // state.quoteObj.totalPremium = props.generateQuoteData.selectedPlan.totalPremium;
        // if(props.generateQuoteData.businessType == "NEW"){
        //     state.quoteObj.regNo = "NEW"
        // }
        // else{
        //     state.quoteObj.regNo = props.generateQuoteData.riskDetails.registrationNumber.value;
        // }
        // state.quoteObj.title = props.proposalDetailsData.customerDetails.title.value;
        // state.quoteObj.firstName = props.proposalDetailsData.customerDetails.firstName.value;
        // state.quoteObj.middleName = props.proposalDetailsData.customerDetails.middleName.value;
        // state.quoteObj.lastName = props.proposalDetailsData.customerDetails.lastName.value;
        // state.quoteObj.address = props.proposalDetailsData.correspondenceAddress.address.value;
        // state.quoteObj.emailId = props.proposalDetailsData.correspondenceAddress.emailId.value;
        // state.quoteObj.mobileNumber = props.proposalDetailsData.correspondenceAddress.mobileNumber.value;
        // state.quoteObj.engineNumber = props.proposalDetailsData.vehicleDetails.engineNumber.value;
        // state.quoteObj.chassisNumber = props.generateQuoteData.riskDetails.chassisNumber.value;
        // state.quoteObj.nomineeName = props.proposalDetailsData.personalAccidentCoverDetails.nomineeName.value;
        // state.quoteObj.nomineeRelation = props.proposalDetailsData.personalAccidentCoverDetails.nomineeRelation.value;
        // state.quoteObj.panNumber = props.proposalDetailsData.correspondenceAddress.panNumber.value;
    }
    //return
    return{
      state,
      setQuoteSummary,
      checkMotorParent,
    }
  }
};
</script>

<style scoped>
/* app-overview css */
.break-word{
    word-break: break-all;
    display: block;
    width: 170px;
}
.app-overview-wrapper {
    background-color: #ffffff;
    width: calc(100% + 66px);
    max-width: 1366px;
    margin: 30px -34px 0 -32px;
    box-shadow: -10px 0 16px 5px rgba(128, 152, 213, 0.08);
    width: 100%;
    /* border: solid 1px #e8ebf2; */
}
.app-overview-row {
    padding-left: 32px;
    padding-top: 20px;
    padding-bottom: 10px;
}
.preview-btn-wrapper {
    position: absolute;
    top: 15px;
    /* right: 20px; */
    left: 87%;
}
.preview {
    background-color: transparent;
    color: #0070be;
    border: none;
    cursor: pointer;
    font-size: 14px;
    font-weight: bold;
    margin-top: 16px;
}
.app-overview-outer-div {
    background-color:#f2f2f2;
}
.app-overview-inner-div {
    background-color: #ffffff;
    margin: 10px;
}
.label-name {
    color: #666666;
    font-size: 14px;
}
.label-value {
    color: #ff9b41;
    font-weight: bold;
    font-size: 17px;
}
.inner-label-value {
    color: #333333  ;
    font-weight: bold;
    font-size: 16px;
    word-break: break-word;
}
.table-striped>tbody>tr:nth-child(2n)>td,
.table-striped>tbody>tr:nth-child(2n)>th {
    background-color: #f2f2f2; 
}
.table-striped>tbody>tr:nth-child(2n+1)>td,
.table-striped>tbody>tr:nth-child(2n+1)>th {
    background-color: #fff;
}
.table-striped>thead th:first-child {
    width: 40%;
}
.loader-small img {
    width: 25px;
    height: 25px;
    margin-top: 0px;
    margin-right: 0;
}
.table > thead th{
    font-size: 16px;
}
.loader.inline img {
    margin-top: 2px ;
    margin-right: 0px;
    margin-left: 7px;
}
@media(max-width: 991px){
  .review-application{
      left: 70%;
      top: 70%;
  }
}
@media (max-width: 767px){
  .app-overview-inner-div .label-name , .inner-label-value{
     font-size:14px ;
  }
  .table > thead th {
     font-size: 14px;
  }
  #details_payment .table > thead th {
     padding-left: 0px;
  }
  #details_payment .table > tbody td {
     padding-left: 0px;
     padding-left: 8px ;
  }
  .review-application{
      top: 75%;
  }
}
@media (max-width: 511px){
  .label-name{
     font-size:12px ;
  }
  .label-value{
     font-size: 14px ;
  }
  .review-application{
     left: 50%;
  }
} 
@media(max-width: 1159px) and (min-width: 992px) {
  .quote-summary{
     max-width: 14%;
  }
}
@media(max-width: 1139px) and (min-width: 992px) {
  .total-premiun-row{
     margin-left: 12px;
  }
  .plan-tenure-row{
     margin-left: 0px;
  }
}
@media(max-width: 1112px) and (min-width: 992px) {
  .total-premiun-row{
     margin-left: 0px;
  }
  .plan-name-row{
     margin-left: 15px;
  }
  .product-name-row{
     margin-left: 20px;
  }
  .make-n-model-row{
      margin-left: 8px;
  }
  .quotation-number-row{
      margin-left: 0px;
  }
}
@media(min-width : 1202px){
    .product-name{
        position: relative;
        right: 17px;
    }
}
@media(min-width : 1160px){
  .quotation-number-row{
    position: relative;
    right: 38%;
  }
  .make-n-model-row{
    position: relative;
    right: 40%;  
  }
  .product-name-row{
    position: relative;
    right: 60%;  
  }
  .plan-name-row{
    position: relative;
    right: 22%;  
  }
}
</style>
